import { render, staticRenderFns } from "./RegimeExplanationBadge.vue?vue&type=template&id=130d1f2c&scoped=true"
import script from "./RegimeExplanationBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./RegimeExplanationBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RegimeExplanationBadge.vue?vue&type=style&index=0&id=130d1f2c&prod&scoped=true&lang=css"
import style1 from "./RegimeExplanationBadge.vue?vue&type=style&index=1&id=130d1f2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d1f2c",
  null
  
)

export default component.exports